import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import BulkCaptionUpload from "./BulkCaptionUpload";

const CaptionsPage = ({ buttonColor, currentLanguage }) => {
  const { userId } = useParams();
  return <BulkCaptionUpload userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />;
};

// Wrap with layout
const CaptionsPageWithLayout = () => (
  <WayfinderLayout>
    <CaptionsPage />
  </WayfinderLayout>
);

export default CaptionsPageWithLayout;
